// 「ショップで検索」等のaタグで検索条件のon,offを表現している所用
$(function(){
    $("form#product_search").each(function(){
        $form =$(this);

        $(".checkbox_link").click(function(){
            $checkbox = $(this).next();
            if($(this).hasClass("is-current"))
            {
                $(this).removeClass("is-current");
                $checkbox.prop("checked", false);
            } else {
                $(this).addClass("is-current");
                $checkbox.prop("checked", true);
            }
            $form.find("#product_search_submit").click();
        });
    });
});
